export default "__VITE_ASSET__DY2U0F3e__"